import React from 'react';
import { Text, Tooltip } from '@chakra-ui/react';
import utils from '@happylife-a/utils';

export default function TruncatedText({
  text,
  maxLength = 30,
  variant = 'body-reg-lg',
  color = 'grey.900',
  width,
  emptyText = '-',
  tooltipProps = {},
  textProps = {},
}) {
  // Handle empty text
  if (!text) {
    return (
      <Text variant={variant} color={color} {...textProps}>
        {emptyText}
      </Text>
    );
  }

  const shouldTruncate = text.length > maxLength;
  const displayText = shouldTruncate ? utils.helpers.string.truncate(text, maxLength) : text;

  const textElement = (
    <Text
      variant={variant}
      color={color}
      w={width}
      cursor={shouldTruncate ? 'help' : undefined}
      {...textProps}
    >
      {displayText}
    </Text>
  );

  // If text is truncated, wrap in tooltip
  if (shouldTruncate) {
    return (
      <Tooltip
        label={text}
        placement="top"
        hasArrow={true}
        bg="gray.700"
        color="white"
        px={3}
        py={2}
        borderRadius="md"
        {...tooltipProps}
      >
        {textElement}
      </Tooltip>
    );
  }

  return textElement;
}
